import MenuList from '@material-ui/core/MenuList';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import HomeIcon from '@material-ui/icons/Home';
import * as React from 'react';
import { IMiaRouteMatchResponse } from '../components/hooks';
import { NavTypes, NavUrls } from './layoutConstants';
import { MenuLink } from './MenuLink';
import { DealerPortalMenu } from './menus/DealerPortalMenu';
import { FinanceMenu } from './menus/FinanceMenu';
import { InfoTechMenu } from './menus/InfoTechMenu';
import { LogisticsMenu } from './menus/LogisticsMenu';
import { MarketingMenu } from './menus/MarketingMenu';
import { OperationsMenu } from './menus/OperationsMenu';
import { SalesMenu } from './menus/SalesMenu';

interface ILeftNavMenuProps {
  onNavClick: () => any;
  matches: IMiaRouteMatchResponse | null;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    nested: {
      paddingLeft: theme.spacing(4)
    }
  })
);

export interface ILeftNavMenuItem {
  url: NavUrls;
  icon: React.ReactElement;
  label: string;
}

let LeftNavMenu: React.FunctionComponent<ILeftNavMenuProps> = ({ onNavClick, matches }) => {
  const classes = useStyles();
  const [openNav, setOpenNavs] = React.useState<NavTypes[]>([]);
  const handleExpand = React.useCallback(
    (navType: NavTypes) =>
      setOpenNavs(current => (current.includes(navType) ? current.filter(n => n !== navType) : [...current, navType])),
    []
  );

  const pathname = React.useMemo(() => matches?.currentRoute.pathname ?? '', [matches?.currentRoute.pathname]);

  return (
    <MenuList>
      <MenuLink
        icon={<HomeIcon />}
        to={NavUrls.root}
        label="Home"
        onNavClick={onNavClick}
        isActive={pathname === NavUrls.root}
      />
      <SalesMenu
        onExpandClick={handleExpand}
        collapsed={openNav.includes('sales')}
        menuClassName={classes.nested}
        onNavClick={onNavClick}
        navType="sales"
        currentLocation={pathname}
      />
      <DealerPortalMenu
        onExpandClick={handleExpand}
        collapsed={openNav.includes('dealerPortal')}
        menuClassName={classes.nested}
        onNavClick={onNavClick}
        navType="dealerPortal"
        currentLocation={pathname}
      />
      <MarketingMenu
        onExpandClick={handleExpand}
        collapsed={openNav.includes('marketing')}
        menuClassName={classes.nested}
        onNavClick={onNavClick}
        navType="marketing"
        currentLocation={pathname}
      />
      <FinanceMenu
        onExpandClick={handleExpand}
        collapsed={openNav.includes('finance')}
        menuClassName={classes.nested}
        onNavClick={onNavClick}
        navType="finance"
        currentLocation={pathname}
      />
      <LogisticsMenu
        onExpandClick={handleExpand}
        collapsed={openNav.includes('logistics')}
        menuClassName={classes.nested}
        onNavClick={onNavClick}
        navType="logistics"
        currentLocation={pathname}
      />
      <OperationsMenu
        onExpandClick={handleExpand}
        collapsed={openNav.includes('operations')}
        menuClassName={classes.nested}
        onNavClick={onNavClick}
        navType="operations"
        currentLocation={pathname}
      />
      <InfoTechMenu
        onExpandClick={handleExpand}
        collapsed={openNav.includes('it')}
        menuClassName={classes.nested}
        onNavClick={onNavClick}
        navType="it"
        currentLocation={pathname}
      />
    </MenuList>
  );
};

LeftNavMenu = React.memo(LeftNavMenu);
export { LeftNavMenu };
